module.exports = __webpack_public_path__ + "sunlight.jpg?856e5cc3ffddc2d2d5395ede2d5a0d56";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/sunlight.jpg
// module id = 142
// module chunks = 0